/* MISSION 2016 — Ambient Studio section scripts (idempotent) */
(function () {
  if (window.__m16Init) return;
  window.__m16Init = true;

  function init(root) {
    root = root || document;

    /* Scroll reveals */
    var toReveal = root.querySelectorAll('.m16 .reveal:not(.m16-observed)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      toReveal.forEach(function (el) { el.classList.add('m16-observed'); io.observe(el); });
    } else {
      toReveal.forEach(function (el) { el.classList.add('in', 'm16-observed'); });
    }

    /* Seamless marquee: duplicate track content once */
    root.querySelectorAll('.m16 .marquee-track:not(.m16-dup)').forEach(function (track) {
      track.classList.add('m16-dup');
      track.innerHTML += track.innerHTML;
    });

    /* Hero dimmer */
    root.querySelectorAll('.m16-hero').forEach(function (hero) {
      var range = hero.querySelector('.dimmer input[type=range]');
      var dim = hero.querySelector('.hero-dim');
      if (range && dim && !range.__m16) {
        range.__m16 = true;
        range.addEventListener('input', function () { dim.style.opacity = range.value / 100; });
      }
      /* Cursor glow */
      if (!hero.__m16Glow) {
        hero.__m16Glow = true;
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
          hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
        });
      }
    });

    /* Neon glow follows cursor */
    root.querySelectorAll('.m16.neon-sec').forEach(function (sec) {
      if (sec.__m16Glow) return;
      sec.__m16Glow = true;
      sec.addEventListener('pointermove', function (e) {
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* Re-init inside the Theme Editor when sections re-render */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.m16 .reveal').forEach(function (el) { el.classList.add('in'); });
    init();
  });
})();
